// src/components/ProtectedRoute.jsx

import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute() {
  const { isAuthenticated, initialized } = useAuth();
  const location = useLocation();

  // Prevents route rendering before auth initialization completes
  if (!initialized) {
    return null; // Replace with loader if desired
  }

  // If not authenticated, redirect to login
  // Preserve intended destination in state
  if (!isAuthenticated) {
    return (
      <Navigate
        to="/auth"
        replace
        state={{ from: location }}
      />
    );
  }

  // Authenticated → render nested routes
  return <Outlet />;
}
